// Types matching the docker_operations API contract (TASK-2494).
// Backend: src/consoleai/docker_operations.py + endpoints in api.py.

export type OperationStatus = 'running' | 'success' | 'failed' | 'cancelled'

export type PhaseName =
  | 'inspecting'
  | 'stopping'
  | 'cleaning_volumes'
  | 'pulling'
  | 'recreating'
  | 'awaiting_healthy'

export type PhaseStatus = 'pending' | 'running' | 'success' | 'failed'

export interface PhaseEntry {
  name: PhaseName
  status: 'running' | 'success' | 'failed'
  started_at?: string
  ended_at?: string
  output?: string
  metadata?: Record<string, unknown>
  error?: string
}

export interface DockerOperation {
  id: string
  tenant_id: number
  instance_id: string
  container_name: string
  operation_type: 'hard_restart'
  status: OperationStatus
  current_phase: PhaseName | null
  phases: PhaseEntry[]
  reason: string
  clean_volumes: boolean
  started_by_user_id: number
  started_at: string
  ended_at: string | null
  output_meta: Record<string, unknown>
}

export interface StartHardRestartRequest {
  reason: string
  confirmation: boolean
  clean_volumes: boolean
}

export interface StartHardRestartResponse {
  operation_id: string
  status: 'running'
}

// ── Cardiograph state model ─────────────────────────────────────────────
//
// Drives the SVG trace's amplitude/rhythm/colour. Mapped from operation
// status + current_phase via `cardiographStateFromOperation` in
// `cardiographMotion.ts`.

export type CardiographState =
  | 'idle' // no operation yet (used in preflight)
  | 'inspecting'
  | 'stopping'
  | 'stopped' // brief plateau between stop and clean/pull
  | 'cleaning_volumes'
  | 'pulling'
  | 'recreating'
  | 'awaiting_healthy'
  | 'healthy' // terminal success
  | 'failed' // terminal failure

// Display ordering for the timeline. Conditional cleaning_volumes excluded
// when clean_volumes=false at orchestrator level (server-side).
export const PHASE_ORDER: PhaseName[] = [
  'inspecting',
  'stopping',
  'cleaning_volumes',
  'pulling',
  'recreating',
  'awaiting_healthy',
]

export const PHASE_LABELS: Record<PhaseName, string> = {
  inspecting: 'Inspecionando',
  stopping: 'Parando container',
  cleaning_volumes: 'Limpando volumes',
  pulling: 'Baixando imagem',
  recreating: 'Recriando',
  awaiting_healthy: 'Aguardando healthy',
}
